import React from 'react';
import { useParams } from 'react-router-dom';
import ListTemplate from '../../../Reusable_Components/ListTemplate';
import { API_ROUTES, API_DOMAIN } from '../../../Reusable_Components/Config/apiConfig';
import { fmtDateTime } from '../../../../utils/fmt';

const CustomerActivityList = () => {
  const { customerId } = useParams();

  const decodedCustomerId = customerId ? atob(customerId).replace(/\D/g, '') : '';
  const fetchUrl = decodedCustomerId
    ? `${API_DOMAIN}${API_ROUTES.customerActivity}?customer=${decodedCustomerId}`
    : `${API_DOMAIN}${API_ROUTES.customerActivity}`;

  const columns = [
    { label: 'Subject', value: 'subject' },
    { label: 'Scheduled Date', value: (item) => fmtDateTime(item.scheduled_date) },
    { label: 'Completed', value: item => item.is_completed ? 'Yes' : 'No' },
    { label: 'Activity Type', value: item => item.activity_type?.name || 'N/A' },
    { label: 'Assigned To', value: item => item.assigned_to?.username || 'N/A' },
  ];

  const handleAccessDetails = (id) => {
    window.location.href = `/customer/activity/details/${id}`;
  };

  return (
    <div>
      <h1>Customer Activities</h1>
      <ListTemplate
        fetchUrl={fetchUrl}
        columns={columns}
        onAccessDetails={handleAccessDetails}
      />
    </div>
  );
};

export default CustomerActivityList;
